export default [
  require("/home/runner/work/deriv-api-docs/deriv-api-docs/node_modules/infima/dist/css/default/default.css"),
  require("/home/runner/work/deriv-api-docs/deriv-api-docs/node_modules/@docusaurus/theme-classic/lib/prism-include-languages"),
  require("/home/runner/work/deriv-api-docs/deriv-api-docs/node_modules/@docusaurus/theme-classic/lib/nprogress"),
  require("/home/runner/work/deriv-api-docs/deriv-api-docs/src/styles/index.scss"),
];
